export const pleatpacks = {
  sharedActions: {
    scheduling: ['Admin', 'Chief', 'PleatsPacksChief', 'PleatsPacksOperator'],
    schedulingSierra: [
      'Admin',
      'Chief',
      'PleatsPacksChief',
      'PleatsPacksOperator',
    ],
    schedulingClip: [
      'Admin',
      'Chief',
      'PleatsPacksChief',
      'PleatsPacksOperator',
    ],
    validation: ['Admin', 'Chief', 'PleatsPacksChief'],
    packingBox: [
      'Admin',
      'Chief',
      'Viewer',
      'QualityControl',
      'QualityControlInspector',
      'LabelOperator',
      'PleatPackLabelOperator',
    ],
    dailyPlanning: [
      'Chief',
      'Admin',
      // 'PleatsPacksAdmin',
      // 'PleatsPacksChief',
      // 'PleatsPacksSupervisor',
      'StandardsAdmin',
      // 'PleatsPacksStandardsAdmin',
      'PleatsPacksEngineer', //created
    ],
  },

  routerActions: {
    // No rutas exclusivas del Router
  },

  sideNavActions: {
    root: ['Chief', 'PleatsPacksChief', 'PleatsPackOperator', 'Admin'],
    reportsPbiPleatPacks: [
      'Chief',
      'PleatsPacksChief',
      'PleatsPackOperator',
      'Admin',
    ],
  },
};
